import { render, staticRenderFns } from "./EditReasonModal.vue?vue&type=template&id=ef777bd2&"
import script from "./EditReasonModal.vue?vue&type=script&lang=js&"
export * from "./EditReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports